import { VarKey } from '../../Variables/Generated/VarKey.Data'
import { CoreType } from '../../Core/Core.Interfaces'
import { GenericTableSchemaInterface } from '../../Table/Table.Interfaces'

export const ProfileCollect00Table: GenericTableSchemaInterface = {
  id: 'profile-collect-00',
  name: 'Profile Collect 00',
  description: 'This table contains data regarding the profile collect funnel.',
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: 'Operator Name',
      variable: VarKey.OrgName
    },
    c02: {
      name: 'Facility ID',
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: 'Journey Start'
    },
    c04: {
      name: 'Funnel',
      variable: VarKey.UserProfileCollectHolder
    },
    c05: {
      name: 'Funnel Start'
    },
    c06: {
      name: 'Completed Profile'
    },
    c07: {
      name: 'Profile Length'
    },
    c08: {
      name: 'Primary Contact Method'
    },
    c09: {
      name: 'Collection Type'
    },
    c10: {
      name: 'Collection Start'
    },
    c11: {
      name: 'Name Unknown'
    },
    c12: {
      name: 'Name Collected'
    },
    c13: {
      name: 'Email Unknown'
    },
    c14: {
      name: 'Email Collected'
    },
    c15: {
      name: 'Phone Unknown'
    },
    c16: {
      name: 'Phone Collected'
    },
    c17: {
      name: 'Card Saved'
    }
  }
}
